<template>
  <div v-if="asAnswer">
    <ul>
      <li
        v-for="option in researchItem.item.options"
        :key="option[0]"
      >
        <span :class="{'text-bold': researchItem.answer.value_str === option}">
          <i class="fa fa-check" v-if="researchItem.answer.value_str === option"></i>
          {{ option[1] }}
        </span>
      </li>
    </ul>
  </div>
  <div class="item-dropdown" v-else>
    <select
      class="form-control form-control-lg"
      :id="itemId"
      v-model="researchItem.answer.value"
    >
      <option disabled selected value>
        {{ $t('phrase.make_a_choice') }}
      </option>
      <option
        v-for="option in researchItem.options"
        :key="option"
        :value="option"
      >
        {{ option }}
      </option>
    </select>
  </div>
</template>

<script>
import { GenericItemMixin } from '@/reviewer/mixins';

export default {
  name: 'ItemDropdown',
  mixins: [
    GenericItemMixin,
  ],
  computed: {
    value() {
      return this.researchItem.answer.value;
    },
    itemId() {
      return this.idPrefix ? `${this.idPrefix}-item-dropdown` : 'item-dropdown';
    },
  },
  watch: {
    value() {
      if (this.value) {
        this.$emit('value-changed');
      }
    },
  },
};

</script>


<style>
div.item-dropdown select.form-control {
  background-color: rgb(255, 255, 255) !important;
}
</style>
